import type { AxiosResponse } from 'axios'
import type {
  CreateProductApiItemInput,
  ListProductApisParams,
  ListProductApisResponse,
  ProductApiItem,
} from '@/types/productApi'
import APIService from '@/services/base'

export class ProductApisService {
  static list(params: ListProductApisParams): Promise<ListProductApisResponse> {
    return APIService.get('/v1/product-apis', { params }).then(
      (res: AxiosResponse<any>) => {
        const body = res.data
        // Backend returns { items, meta: { total, page, limit, totalPages, hasNext, hasPrev } }
        const mapped: ListProductApisResponse = {
          data: body.items ?? [],
          meta: {
            itemCount: body.meta?.total ?? 0,
            page: body.meta?.page ?? params.page ?? 1,
            take: body.meta?.limit ?? params.take ?? 20,
            pageCount: body.meta?.totalPages ?? 0,
            hasNextPage: body.meta?.hasNext ?? false,
            hasPreviousPage: body.meta?.hasPrev ?? false,
          },
        }
        return mapped
      },
    )
  }

  static bulkCreate(
    payload: CreateProductApiItemInput[],
  ): Promise<AxiosResponse<{ success: boolean }>> {
    return APIService.post('/v1/product-apis/bulk', payload)
  }

  static update(
    id: string,
    payload: Partial<CreateProductApiItemInput>,
  ): Promise<AxiosResponse<ProductApiItem>> {
    return APIService.patch(`/v1/product-apis/${id}`, payload)
  }

  static delete(id: string): Promise<AxiosResponse<{ success: boolean }>> {
    // Bulk delete endpoint expects body: { ids: [id] }
    return APIService.delete('/v1/product-apis/bulk', { data: { ids: [id] } })
  }
}
